import LinearProgress from '@mui/material/LinearProgress';
import ErrorPage from '../components/common/ErrorPage';
import MarkData from '../components/mark/MarkData';
import TopBar from '../components/common/TopBar';
import errorResponses from '../errorResponses';
import useSetOrg from '../components/hooks/useSetOrg';
import useGetTrainingSet from '../components/hooks/useGetTrainingSet';
import TrainingSetHeader from '../components/train/TrainingSetHeader';
import TableStyles from '../components/documents/Table.module.css';
import { getIdFromUrl } from '../utils/getIdFromUrl';
import { useParams } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';

function MarkPage() {
  const { dpid, id, did } = useParams<{
    dpid: string;
    id: string;
    did: string;
  }>();

  if (!id) {
    throw new Error("Missing 'id' parameter");
  }

  const { loading, error } = useSetOrg(dpid);
  const { data: trainingSet, isLoading: trainingSetLoading } = useGetTrainingSet(id, true, dpid);

  useSetTitle(trainingSet?.label ? `Mark - ${trainingSet?.label}` : '...');

  if (loading || trainingSetLoading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  }

  const docIds = trainingSet?.documents.map((url) => getIdFromUrl(url)) || [];
  const docIndex = did ? docIds.indexOf(did) : 0;

  return (
    <>
      <TopBar />
      <div className={TableStyles.extractionBatchHeaderWrapper}>
        <TrainingSetHeader trainingSet={trainingSet} dpid={dpid!} tsid={id} />
      </div>
      <MarkData docIndex={docIndex} docIds={docIds} trainingSet={trainingSet} />
    </>
  );
}

export default MarkPage;
